import { AxiosInstance } from 'axios'

import { toGsResponse } from '../../goodstack'

import { GetPartnerDonationMatchingConfigResponse } from './getPartnerDonationMatchingConfig.types'

export const getPartnerDonationMatchingConfig = async (
  client: AxiosInstance
): Promise<GetPartnerDonationMatchingConfigResponse | undefined> =>
  client
    .get<GetPartnerDonationMatchingConfigResponse>(`v1/partner/donation-matching/config`, {
      withCredentials: true,
      validateStatus: code => [200, 404].includes(code)
    })
    .then(r => toGsResponse(r.status, r.data))
    .then(r => (r.result === 'success' ? r : undefined))
    .catch(() => undefined)
